import { render, staticRenderFns } from "./oa.vue?vue&type=template&id=24bc0ff6&"
import script from "./oa.vue?vue&type=script&lang=js&"
export * from "./oa.vue?vue&type=script&lang=js&"
import style0 from "./oa.vue?vue&type=style&index=0&id=24bc0ff6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports